
<a-layout-header :class="[fixHeader && 'ant-header-fixedHeader', layout === 'side' && !isMobile ? (sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed') : null, theme, 'global-header' ]">
  <div :class="['global-header-wide', layout]">
    <router-link v-if="isMobile || layout === 'head'" to="/" :class="['logo', isMobile ? null : 'pc', theme]">
      <img width="32" src="/static/img/logo.png" alt="" />
      <h1 v-if="!isMobile">{{systemName}}</h1>
    </router-link>
    <a-divider v-if="isMobile" type="vertical" />
    <button v-if="isMobile || layout === 'side'" class="trigger" :aria-label="collapsed ? '展开菜单' : '收起菜单'" :aria-expanded="!collapsed" @click="toggleCollapse"><a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" /></button>
    <div v-if="!isMobile && layout === 'head'" class="global-header-menu">
      <i-menu style="height: 64px; line-height: 64px;" class="system-top-menu" :theme="theme" mode="horizontal" :menuData="menuData" @select="onSelect"/>
    </div>
    <div :class="['global-header-right', theme]">
        <header-avatar class="header-item"/>
    </div>
  </div>
</a-layout-header>
